// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

// highlightedPaths and modalPathsSet must be different
// because a single path can be deleted from the
// path's menu while other paths remain selected
const initialState = fromJS({
  asrCheck: false,
  analysisStatus: null,
  canUserEdit: false,
  callSignCheck: false,
  createUser: null,
  companies: [],
  defaultCompany: null,
  defaultContact: null,
  deletedFlag: null,
  error: '',
  filterInput: '',
  filterSelect: 'band',
  filterCheckbox: false,
  highlightedPaths: [],
  isFetching: false,
  lastModifiedUser: null,
  lastModifiedTimestamp: null,
  modalError: '',
  modalMessage: '',
  modalPathsSet: [],
  modalTemplate: '',
  openPanel: '',
  paths: [],
  projectId: null,
  projectName: '',
  projectStatus: null,
  projectType: null,
  // the sorting of tables is generally managed within the table component's state
  // however here, since project summary paths are special, we have to take some different measures.
  sortAsc: true,
  sortCol: 'pathIndex',
  unitType: '', // the project's default unit type
  visiblePathIds: [], // an array of filtered and sorted path ids
  warningsCheck: false, // Warnings document, think ASR/Call Sign checks
})

export default initialState
